import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'DATA_SECURITY',
    icon: 'menu-data-security',
    label: '数据安全',
    remark: '系统中的数据权限相关设置',
    children: [
      {
        code: 'COLUMN_LEVEL_SECURITY',
        icon: 'menu-column-level-security',
        label: '数据权限',
        remark: '默认安全：字段默认不可见/脱敏，在这里按角色/部门/用户放开',
        path: '/column-level-security',
      },
      {
        code: 'ROW_LEVEL_SECURITY',
        icon: 'menu-row-level-security',
        label: '行级隔离',
        remark: '配置哪些人能看到哪些表的哪些行数据',
        path: '/row-level-security',
      },
      {
        code: 'FIELDS_SETTING',
        icon: 'menu-fields-setting',
        label: '数据设置',
        remark: '按企业统一配置各页面字段的显隐、名称、排序',
        path: '/fields-setting',
      },
    ],
  },
] satisfies Menu[];
